import { useEffect } from 'react';

/**
 * 让页面中带 .lovemo-reveal 的元素在进入视口时做一次淡入上移动画。
 */
export function useLovemoReveal() {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll<HTMLElement>('.lovemo-reveal'));
    if (elements.length === 0) return;

    const revealAll = () => {
      elements.forEach((el) => el.classList.add('is-visible'));
    };

    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' },
    );

    elements.forEach((el) => observer.observe(el));

    // 兜底：个别内置浏览器里观察器可能不触发，超时后强制显示，避免内容一直隐藏
    const safetyTimer = window.setTimeout(() => {
      revealAll();
      observer.disconnect();
    }, 3000);

    return () => {
      window.clearTimeout(safetyTimer);
      observer.disconnect();
    };
  }, []);
}